import * as yup from 'yup'

export const inspectionValidationSchema = yup.object({
  aircraft: yup.object().nullable().required('Aircraft is required'),
  general_info: yup.object({
    checklist_ref: yup
      .mixed()
      .required()
      .test('Checklist test', 'Invalid checklist.', (value) => {
        return ['object', 'string'].includes(typeof value)
      }),
    checklist: yup
      .mixed()
      .required()
      .test('Checklist test', 'Invalid checklist.', (value) => {
        return ['object', 'string'].includes(typeof value)
      }),
    customer: yup.object().nullable(),
    inspection_company: yup.object().nullable(),
    operator: yup.object().nullable(),
    inspector: yup.object().nullable().required('Inspector is required'),
    country: yup.string().nullable(),
    region: yup.string().nullable(),
    due_date: yup.date().nullable(),
    contact_info: yup.object().nullable(),
    inspection_number: yup.string().nullable(),
    aircraft_register: yup.string().nullable(),
    yom: yup.date().nullable(),
    project: yup.string().nullable(),
    po_number: yup.string().nullable(),
    po_item: yup.string().nullable(),
    additional_inspectors: yup.array().nullable(),
  }),
})
export const inspectionImageValidationSchema = yup.object({
  photo: yup.mixed().nullable(),
  photo_url: yup.string().nullable(),
  image_source: yup.string().nullable(),
  enable_delete: yup.boolean(),
})
